export const ActivityTableHeadCells = [
  { id: "id", label: "ID" },
  { id: "owner_id", label: "id" },
  { id: "name", label: "Namn" },
  { id: "cost", label: "Pris" },
  { id: "account", label: "Konto" },
  { id: "isActive", label: "Aktiv" },
];

export const ActivityDetailsTabs = [{ id: 1, label: "översikt" }];
